function convertToKoreanNumber(value: string) {
  if (value === '') {
    return '';
  }
  const han1 = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  const han2 = ['', '십', '백', '천'];
  const han3 = ['', '만', '억', '조', '경'];
  let result = '';
  const len = value.length;
  let nowInt = 0;
  let hasHan3 = false;
  for (let i = len; i > 0; i--) {
    nowInt = Number(value.substring(len - i, len - i + 1));
    const han2Pick = (i - 1) % 4;
    if (nowInt > 0) {
      result += han1[nowInt] + han2[han2Pick];
      if (han2Pick > 0) {
        hasHan3 = false;
      }
    }
    if (!hasHan3 && han2Pick == 0) {
      result += han3[(i - 1) / 4];
      hasHan3 = true;
    }
  }

  if (result.includes('일')) {
    return (
      result
        .split('')
        .map((v, index) => {
          if (v !== '일') return v;
          if (index === result.length - 1) return v;
          return;
        })
        .join('') + '원'
    );
  }
  return result + '원';
}

export const step7 = {
  get capital() {
    return this.userInput.capital.replace(/,/g, '');
  },

  get capitalAsHumanReadable() {
    return convertToKoreanNumber(this.capital);
  },

  get isNextBtnActive() {
    return parseInt(this.capital) > 0;
  },

  skip() {
    this.userInput.capital = '0';
    this.moveNext();
  },
};
